import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=134d09b2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=134d09b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d09b2",
  null
  
)

export default component.exports